import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AssetWizardModalPage } from './asset-wizard-modal.page';
import { QuizAssetWizardComponent } from './quiz-asset-wizard/quiz-asset-wizard.component';
import { StepQuizDetailsComponent } from './quiz-asset-wizard/step-quiz-details/step-quiz-details.component';
import { StepQuizQuestionsComponent } from './quiz-asset-wizard/step-quiz-questions/step-quiz-questions.component';
import { StepQuizQuestionPropertiesComponent } from './quiz-asset-wizard/step-quiz-question-properties/step-quiz-question-properties.component';
import { StepQuizConfirmationComponent } from './quiz-asset-wizard/step-quiz-confirmation/step-quiz-confirmation.component';
import { StepQuizResultsComponent } from './quiz-asset-wizard/step-quiz-results/step-quiz-results.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from 'src/app/callback.pipes.module';
import { QuestionAssetWizardComponent } from './question-asset-wizard/question-asset-wizard.component';
import { StepQuestionDetailsComponent } from './question-asset-wizard/step-question-details/step-question-details.component';
import { StepQuestionPropertiesComponent } from './question-asset-wizard/step-question-properties/step-question-properties.component';
import { StepHelpComponent } from './quiz-asset-wizard/step-help/step-help.component';
import { StepQuestionHelpComponent } from './question-asset-wizard/step-question-help/step-question-help.component';
import { InformationPopupComponent } from './information-popup/information-popup.component';
import { ResourceDirectivesModule } from 'src/app/directives/resource-directives.module';

const routes: Routes = [
  {
    path: '',
    component: AssetWizardModalPage
  }
];

@NgModule({
  imports: [
    ResourceDirectivesModule,
    CommonModule,
    FormsModule,
    IonicModule,
    NgxPaginationModule,
    PipesModule,
    RouterModule.forChild(routes),
    ColorPickerModule
  ],
  declarations: [
    AssetWizardModalPage,
    QuizAssetWizardComponent,
    StepQuizDetailsComponent,
    StepQuizQuestionsComponent,
    StepQuizQuestionPropertiesComponent,
    StepQuizConfirmationComponent,
    StepQuizResultsComponent,
    StepHelpComponent,
    QuestionAssetWizardComponent,
    StepQuestionDetailsComponent,
    StepQuestionPropertiesComponent,
    StepQuestionHelpComponent,
    InformationPopupComponent
  ]
})
export class AssetWizardModalPageModule { }
